import { InjectionToken } from '@angular/core';

export const COLLECTION_NAME_TOKEN = new InjectionToken<string>(
	'CollectionName'
);
